export default __webpack_public_path__ + "static/media/trinologo.7eafcc3f.png";